import _regeneratorRuntime from "@babel/runtime/regenerator";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n\n  @media screen and (min-width: ", "px) {\n    min-width: 420px;\n  }\n\n  @media screen and (max-width: ", "px) {\n    width: 100%;\n    margin-top: 10px;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  @media screen and (min-width: ", "px) {\n    min-width: 420px;\n    margin-top: 50px;\n  }\n\n  @media screen and (max-width: ", "px) {\n    margin-top: 0;\n  }\n\n  &.custom-build {\n    > div {\n      border-color: #ff6a00;\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useRef, useState } from 'react';
import { SelectInputV3 as SelectInput, useSessionStorage } from '@acorns/web-components';
import styled from 'styled-components';
import axios from 'axios';
import { style } from '../../../theme';
import { Pagination } from './Pagination';
var StyledSelect = styled(SelectInput)(_templateObject(), style(function (theme) {
  return theme.breakpoints.sm + 1;
}), style(function (theme) {
  return theme.breakpoints.sm;
}));
var Container = styled.div(_templateObject2(), style(function (theme) {
  return theme.breakpoints.sm + 1;
}), style(function (theme) {
  return theme.breakpoints.sm;
}));

var getItemDetails = function getItemDetails(item) {
  return {
    label: item.name,
    value: item.name,
    subtext: item.branch
  };
};

export var BuildList = function BuildList(_ref) {
  var buildOption = _ref.buildOption,
      customBuilds = _ref.customBuilds,
      initCustomBuilds = _ref.initCustomBuilds;
  var storageKey = "".concat(buildOption.projectName, "_builds");

  var _useSessionStorage = useSessionStorage(),
      getItem = _useSessionStorage.getItem,
      setItem = _useSessionStorage.setItem;

  var _useState = useState(buildOption === null || buildOption === void 0 ? void 0 : buildOption.options),
      _useState2 = _slicedToArray(_useState, 2),
      builds = _useState2[0],
      setBuilds = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      currentPage = _useState4[0],
      setCurrentPage = _useState4[1];

  var _useState5 = useState(getItem(storageKey)),
      _useState6 = _slicedToArray(_useState5, 2),
      currentValue = _useState6[0],
      setCurrentValue = _useState6[1];

  var _useState7 = useState([null, (buildOption === null || buildOption === void 0 ? void 0 : buildOption.startKey) || null]),
      _useState8 = _slicedToArray(_useState7, 2),
      pageKeys = _useState8[0],
      setPageKeys = _useState8[1];

  var _useState9 = useState(!!(buildOption === null || buildOption === void 0 ? void 0 : buildOption.startKey)),
      _useState10 = _slicedToArray(_useState9, 2),
      showNext = _useState10[0],
      setShowNext = _useState10[1];

  var prevButtonRef = useRef(null);
  var nextButtonRef = useRef(null);

  var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      isLoading = _useState12[0],
      setIsLoading = _useState12[1];

  var _useState13 = useState(false),
      _useState14 = _slicedToArray(_useState13, 2),
      isSelectOpen = _useState14[0],
      setIsSelectOpen = _useState14[1];

  var handleOnToggle = function handleOnToggle(isOpen) {
    setIsSelectOpen(isOpen);
  };

  var handleChange = function handleChange(field, value) {
    setItem(field, value);
    setCurrentValue(value);
    initCustomBuilds();
  };

  var paginate = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(pageNumber) {
      var pageKey, url, response, _response$data, items, lastEvaluatedKey;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setIsLoading(true);
              pageKey = pageKeys[pageNumber];
              url = "".concat(process.env.MICRO_FRONTEND_LAMBDA, "/").concat(process.env.BUILD_ENV, "/listbuilds?project=").concat(buildOption.projectName, "&limit=20");

              if (pageKey) {
                url += "&startKey=".concat(pageKey);
              }

              _context.next = 6;
              return axios.get(url);

            case 6:
              response = _context.sent;
              _response$data = response === null || response === void 0 ? void 0 : response.data, items = _response$data.Items, lastEvaluatedKey = _response$data.LastEvaluatedKey;

              if (lastEvaluatedKey) {
                setShowNext(true);
                setPageKeys([].concat(_toConsumableArray(pageKeys), [lastEvaluatedKey.timestamp]));
              } else {
                setShowNext(false);
              }

              setBuilds(items === null || items === void 0 ? void 0 : items.map(function (item) {
                return getItemDetails(item);
              }));
              setIsLoading(false);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function paginate(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleNav = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(direction) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return paginate(currentPage + direction);

            case 2:
              setCurrentPage(currentPage + direction);

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleNav(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/React.createElement(Container, null, isSelectOpen && /*#__PURE__*/React.createElement(Pagination, {
    showPrev: currentPage !== 0,
    showNext: showNext,
    handleNav: handleNav,
    nextButtonRef: nextButtonRef,
    prevButtonRef: prevButtonRef
  }), /*#__PURE__*/React.createElement(StyledSelect, {
    openRefs: [nextButtonRef, prevButtonRef],
    className: customBuilds.includes(buildOption.projectName) ? 'custom-build' : '',
    id: "".concat(buildOption.projectName, "_builds"),
    label: buildOption.projectName,
    name: "".concat(buildOption.projectName, "_builds"),
    onChange: handleChange,
    onToggle: handleOnToggle,
    isLoading: isLoading,
    options: builds,
    placeholder: "No build selected",
    defaultLabel: currentValue,
    value: currentValue || ''
  }));
};